module.exports = __webpack_public_path__ + "img/dishwasher_safe.16f30f73.png";